module.exports = __webpack_public_path__ + "media/images/athletes/2468-b8d481a936ca5d58c95928f1d88c88dd.png";